export const GLOBAL_ADMIN = 'is_global_admin';
export const CONTENT_ADMIN = 'is_content_admin';
export const DEMO = 'is_demo_account';
export const DEMO_INDIVIDUAL_LINK = 'is_demo_individual_link_account';
